exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".country-tag {\n  margin: 0 5px 5px 0;\n  border: 1px solid grey; }\n  .country-tag.checked {\n    background-color: green;\n    border: none; }\n", ""]);

